<div
  class="modal fade"
  [ngStyle]="{ display: isOpened ? 'block' : 'none' }"
  #modalRoot
  (keydown.esc)="closeOnEscape ? close() : 0"
  (click)="closeOnOutsideClick ? close() : 0"
  >
  <div class="vertical-alignment-helper">
    <div class="modal-dialog vertical-align-center" (click)="preventClosing($event)">
      <div class="modal-content" [style.width]="contentWidth">
        <div class="modal-header">
          @if (!hideCloseButton) {
            <button type="button" class="close" (click)="close()" title="close">
              <span aria-hidden="true">×</span>
            </button>
          }
          @if (title) {
            <h4 class="modal-title">{{ title }}</h4>
          }
          <div class="modal-title">
            <ng-template [ngTemplateOutlet]="modalHeader?.templateRef!"></ng-template>
          </div>
        </div>
        <div class="modal-body">
          <ng-template [ngTemplateOutlet]="modalBody?.templateRef!"></ng-template>
        </div>
        <div class="modal-footer">
          <ng-template [ngTemplateOutlet]="modalFooter?.templateRef!"></ng-template>
          @if (isFormModal) {
            <div class="pull-left text-warning">
              <small>{{ footerText }}</small>
            </div>
          }
          <div [ngClass]="buttonAlign">
            @if (cancelButtonLabel) {
              <button
                type="button"
                class="btn btn-default btn-secondary"
                data-dismiss="modal"
                (click)="close()"
                >
                {{ cancelButtonLabel }}
              </button>
            }
            @if (displayBackButton) {
              <button
                type="button"
                class="btn btn-default btn-secondary"
                data-dismiss="modal"
                (click)="back()"
                >
                {{ backButtonLabel }}
              </button>
            }
            @if (submitButtonLabel && displaySubmitButton) {
              <button
                type="button"
                class="btn btn-primary ml-1"
                (click)="submit()"
                [disabled]="disableSubmitButton"
                >
                {{ submitButtonLabel }}
              </button>
            }
            @if (displayReviewButton) {
              <button
                [disabled]="disableReviewButton"
                type="button"
                class="btn btn-primary"
                (click)="review()"
                >
                {{ reviewButtonLabel }}
              </button>
            }
          </div>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
</div>
